module.exports = __webpack_public_path__ + "img/UOI1080V01.213725d9.png";